import { render, staticRenderFns } from "./CButtonGroup.vue?vue&type=template&id=2e8f847a&scoped=true&"
import script from "./CButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./CButtonGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CButtonGroup.vue?vue&type=style&index=0&id=2e8f847a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8f847a",
  null
  
)

export default component.exports